import moment from 'moment';

export const toUtcStartOfDay = dat => {
  const date = moment(dat);
  // Build the UTC instant straight from the picked Y/M/D — routing through a
  // local "now" moment and then .utc() (the old approach) shifts the clock by
  // the local UTC offset *before* truncating to midnight, so before ~7am
  // Thailand time (UTC+7) the day rolls back one calendar day.
  return moment.utc({ year: date.year(), month: date.month(), date: date.date() }).toDate();
};
